import { RECALL_AGENT, RecallAgentView } from '@elva/ui';
import { useNavigate } from 'react-router-dom';
import { useRecallHold } from '../hooks/useRecallHold';
import { usePeriodRange } from '@/app/hooks/usePeriodRange';

/**
 * Recall agent page (spec 04, amended by **amendment 24**).
 *
 * Every figure on it is derived (see `recall-agent/derive.ts`), because staging
 * found the page arguing with itself: *per 100 contacted → 24* over 131 from
 * 1,140, and four channel rows adding to 268 against a headline of 131.
 *
 * The campaign workspace lives at `/recall`; configuration at
 * `/settings/ai/recall`.
 */
export function RecallAgentPage() {
  const navigate = useNavigate();
  const { onHold, setHold } = useRecallHold();
  const [period, setPeriod] = usePeriodRange();

  return (
    <RecallAgentView
      data={RECALL_AGENT}
      onHold={onHold}
      onSetHold={setHold}
      period={period}
      onPeriodChange={setPeriod}
      onOpenCampaigns={() => {
        void navigate('/recall');
      }}
      onViewAllRecalls={() => {
        void navigate('/recall');
      }}
      onOpenSettings={() => {
        void navigate('/settings/ai/recall');
      }}
      onOpenTriage={() => {
        void navigate('/calls?type=recall');
      }}
      onViewAllLogs={() => {
        void navigate('/communications?agent=recall');
      }}
    />
  );
}
